import { Attachment } from "@redotech/redo-model/create-conversation-body";
import { ActionType, AutoReply } from "@redotech/redo-model/return-flow/action";
import * as React from "react";
import { ActionTypeSetup, RuleTypeDetailsProps } from "./multiple-actions";

export interface AutoReplyState {
  textContent: string;
  htmlContent: string;
  attachments?: Attachment[];
}

export const AUTO_REPLY = (
  Details: React.ComponentType<RuleTypeDetailsProps<AutoReplyState>>,
): ActionTypeSetup<AutoReplyState, AutoReply> => ({
  name: "Send message",
  description() {
    return "Automatically replies with your provided message";
  },
  Details(props: RuleTypeDetailsProps<AutoReplyState>) {
    return React.createElement(Details, props);
  },
  empty: { textContent: "", htmlContent: "", attachments: [] },
  fromModel(model) {
    return {
      textContent: model.textContent,
      htmlContent: model.htmlContent,
      attachments: model.attachments,
    };
  },
  toModel(state) {
    return {
      type: ActionType.AutoReply,
      htmlContent: state.htmlContent,
      textContent: state.textContent,
      attachments: state.attachments,
    };
  },
  valid(state) {
    return !!(state.textContent && state.htmlContent);
  },
});
